/* CloneAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateComponent = require("../create/CreateComponent");
const _ = require("lodash");

class CloneAction {
    constructor(logger, gameEditor, modalUserFeedback, OsUpgradePlan, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._planEntity = OsUpgradePlan;
        this._modalUserFeedback = this._gameEditor._modalUserFeedback;
        this._activeView = activeView;
        this._userSession = userSession;
        this._firstRun = true;

        this.run = this.run.bind(this);
        this.cloneErrorHandler = this.cloneErrorHandler.bind(this);
    }
    run() {
        if (this._activeView) {
            if (this._activeView.pagingFeed) {
                this._selectedPlanId = this._activeView.selectedRows[0];
                this._planEntity
                    .retrieveOsUpgradePlan(
                        this._userSession.activeOrganization.id,
                        this._selectedPlanId
                    )
                    .then((osPlan) => {
                        this._osPlan = osPlan;
                        this.imageAssociations = this._osPlan.imageAssociations;
                        return this._osPlan.loadRelatedDevices();
                    })
                    .then((devices) => {
                        this.deviceIds = devices.map((device) => {
                            return device.id;
                        });
                        //return this._osPlan.clone(this._osPlan.name.trim() + "-1");
                        return this._cloneOSPlan(this._osPlan.name.trim() + "-1");
                    })
                    //.then((clone) => {
                    //    return this.cloneDevicesAndImages(clone);
                    //})
                    //.then((result) => {
                    //    this.launchEditor(result.id, result.properties.name);
                    //    if (typeof this._activeView.resetSelection === "function") {
                    //        this._activeView.resetSelection([result.id]);
                    //    }
                    //})
                    .catch(this.cloneErrorHandler);
            }
        }
    }

    cloneDevicesAndImages(clone) {
        clone.clearAllImageAssociations();
        return clone
            .addDevicesToPlan(this.deviceIds)
            .then(() => {
                let associateImagesPromiseChain = Promise.resolve();
                _.forEach(this.imageAssociations, (assoc, key) => {
                    associateImagesPromiseChain = associateImagesPromiseChain.then(() => {
                        return clone.associateImagesToKey(
                            key,
                            assoc.protocol,
                            assoc.imageIds,
                            assoc.copyBlockSize
                        );
                    });
                });
                return associateImagesPromiseChain;
            })
            .then(() => {
                clone.setProperty("deviceSuccessCount", 0);
                clone.setProperty("deviceFailureCount", 0);
                clone.setProperty("deviceHealthyCount", 0);
                clone.setProperty("deviceUnhealthyCount", 0);
                if (clone.isDirty()) {
                    return clone.update();
                } else {
                    return Promise.resolve(clone);
                }
            })
            .catch((err) => {
                Promise.reject(err);
            });
    }

    cloneErrorHandler(error) {
        const {userRejected, errorCode} = error;
        if (userRejected) {
            return;
        }
        this._logger.warn({error}, "Clone action error.");
        switch (errorCode) {
            case "EntityAlreadyExists":
                if (this._firstRun) {
                    this._firstRun = false;
                    return this.requestPlanName(false);
                }
                return this.requestPlanName(true);
            default:
                return this.showCloneError(error);
        }
    }

    showCloneError(error) {
        return this._modalUserFeedback.displayError({error}).catch((error) => {
            if (error.userRejected) {
                return;
            }
            this._logger.warn({error}, "Clone action error.");
        });
    }

    _cloneOSPlan(planName) {
        let newItemId;
        return this._osPlan
            .clone(planName)
            .then((clone) => {
                //23103 - Clears the cloned workId thereby making the cloned plan loose logs and work info
                clone.setProperty("lastWorkId", "");
                return this.cloneDevicesAndImages(clone);
            })
            .then((result) => {
                newItemId = result.id;
                return this._modalUserFeedback.hideDisplayed().then(() => {
                    return this.launchEditor(newItemId, result.properties.name, "ALL");
                });
            })
            .then(() => {
                if (typeof this._activeView.resetSelection === "function") {
                    // fix for 22682 - making a small delay, to be sure the grid is updated with new item
                    _.delay(() => this._activeView.resetSelection([newItemId]), 200);
                }
            });
    }

    requestPlanName(isNotUniq) {
        return this._modalUserFeedback
            .displayCustom(
                new CreateComponent(
                    this._logger,
                    "Clone Plan",
                    isNotUniq
                        ? "The entered name is not unique. Please specify a unique name for this cloned device."
                        : "Please specify a unique name for this cloned plan.",
                    ""
                ),
                {dontHide: true}
            )
            .then((result) => {
                return this._modalUserFeedback.displayLoading().then(() => {
                    return this._cloneOSPlan(result.trim());
                });
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    this._logger.warn({error: err}, "CaptureAction.run() - User Canceled");
                    return this._modalUserFeedback.hideDisplayed();
                } else {
                    return this.cloneErrorHandler(err);
                }
            });
    }
    launchEditor(id, name, expandOpt) {
        if (!id) {
            throw "Plan creation error, invalid plan ID.";
        }
        let editorState = {
            fqn: Registrations.OS_PLAN_EDITOR_VIEW_DETAILS,
            viewState: {createMode: true},
        };
        let launchOpts = {id: id, title: name, expandOpt};
        return this._gameEditor.launchPlanEditor(editorState, launchOpts);
    }
}

module.exports = CloneAction;

CloneAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OsUpgradePlan",
    "$teve.userSession",
    "gameEditor.activeView",
];

CloneAction.$displayDetails = {
    type: "Action",
    name: "CloneAction",
    icon: "common.duplicate",
    title: "Clone OS Plan",
    shown: true,
    order: 4,
};
